import { Dispatch, SetStateAction, FunctionComponent, useState } from "react";

import { useTranslation } from "react-i18next";

import { Modal } from "@/components";
import { ReactComponent as MagnifyingGlass } from "@assets/icons/list-builder/magnifying-glass.svg";

import { InputField } from "@/components/InputField/InputField";
import { SvgIcon } from "@/components/Icon/SvgIcon";

interface SearchModalProps {
	showFilterModal: boolean;
	setShowFilterModal: Dispatch<SetStateAction<boolean>>;
	searchValue: string;
	setSearchValue: Dispatch<SetStateAction<string>>;
}

export const SearchModal: FunctionComponent<SearchModalProps> = ({
	showFilterModal,
	setShowFilterModal,
	searchValue,
	setSearchValue,
}) => {
	const { t } = useTranslation();

	const [search, setSearch] = useState<string>(searchValue);

	const onSubmit = () => {
		setSearchValue(search);
	};

	return (
		<Modal
			handleClear={() => {
				setSearch("");
				setSearchValue("");
				setShowFilterModal(false);
			}}
			handleClose={() => setShowFilterModal(false)}
			handleSave={() => {
				onSubmit();
				setShowFilterModal(false);
			}}
			isOpened={showFilterModal}
			size="lg"
			submitButtonText={t("basics.confirm")}
			title={t("basics.toSearch")}
		>
			<div className="flex flex-col">
				<InputField
					handleChange={(e) => setSearch(e.target.value)}
					iconInside={<SvgIcon className="text-gray-500" svgIcon={MagnifyingGlass} />}
					name="search"
					placeholder={t("basics.search", { something: t("sidebar.prospects") })}
					value={search}
				/>
			</div>
		</Modal>
	);
};
